import { useNavigate } from 'react-router-dom';
import { ButtonWithArrowRight, Footer, ScreenWarning } from '~components';
import { useTransshipment } from '~contexts/TranshipmentContext';
import * as Styled from './styled';

function Success() {
  const navigate = useNavigate();
  const transshipment = useTransshipment();

  const handleSubmit = () => {
    navigate(`/`);
  };

  return (
    <>
      <Styled.Title>Tudo certo!</Styled.Title>
      <Styled.Description variant="b500">
        Agora vamos analisar internamente seus dados.
      </Styled.Description>

      <Styled.TranshipmentSuccessfullyCreated />

      {transshipment.type === 'representative' && (
        <>
          <Styled.Hr />
          <Styled.TitleAccopany>Acompanhe sua solicitação</Styled.TitleAccopany>
          <Styled.DescriptionAcconpany variant="b500">
            Um e-mail também foi enviado para você acompanhar sua solicitação
            posteriormente.
          </Styled.DescriptionAcconpany>
          <Footer
            marginTop="auto"
            rightButton={
              <ButtonWithArrowRight
                onClick={handleSubmit}
                width="100%"
                type="submit"
                variant="primary"
              >
                Acompanhar solicitação
              </ButtonWithArrowRight>
            }
          />
        </>
      )}

      {transshipment.type === 'spouse' && (
        <>
          <Styled.ContainerAlert>
            <ScreenWarning message="O resultado da análise será enviado ao representante legal que solicitou a abertura de conta." />
          </Styled.ContainerAlert>
        </>
      )}
    </>
  );
}

export default Success;
